import React from "react";
import { connect } from "react-redux";
import { interfaceActions } from "../../../../common/redux/actions";
import { Row, Col, Skeleton, Affix, Button, message } from "antd";

import ProfileInfo from "../../components/MyProfile/ProfileInfo";
import showConfirmWindow from "../../../../common/components/confirmPopup/confirmPopup";

import * as profileInfoActions from "../../redux/actions/profile/profileActions";
import progresses from "../../components/MyProfile/formProgresses/formProgresses";
import { confirmUpdateProfile } from "../../components/MyProfile/confirm";
import { updateUserAction } from "../../../Authorization/redux/actions/GetUser/updateUserActions";

const { getProfileInfo, updateProfileInfo } = profileInfoActions;
const { setCaption } = interfaceActions;

class MyProfile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      profileId: null,
      isEditable: false,
      formProgress: [...progresses.default]
    };

    this.forms = {};
  }

  componentDidMount() {
    this.props.getProfileInfo();
  }

  componentDidUpdate(prevProps) {
    // Закрывает редактирование после успешного обновления
    if (
      this.state.isEditable &&
      this.props.updateSuccess !== prevProps.updateSuccess
    ) {
      this.handleCancelEdit();
    }
  }

  setForm = (name, form) => {
    if (form) {
      return (this.forms[name] = form);
    } else {
      delete this.forms[name];
      return false;
    }
  };

  getForm = name => {
    if (this.forms.hasOwnProperty(name)) {
      return this.forms[name];
    }
    return false;
  };

  handleClickEdit = () => {
    this.setState(state => ({
      isEditable: true
    }));
  };

  handleCancelEdit = () => {
    this.setState(state => ({
      isEditable: false
    }));
  };

  updateProfile = () => {
    this.formSubmit("formProfileInfo", fieldsValue => {
      let data = {
        ...this.props.activeProfile,
        ...fieldsValue
      };

      this.props.updateUserAction(data);

      this.setState(state => ({
        ...state,
        isEditable: false
      }));
    });
  };

  formSubmit = (name, cbSubmit) => {
    const form = this.getForm(name);
    if (form) {
      form.validateFields((err, fieldsValue) => {
        if (err) {
          return false;
        }

        if (cbSubmit) {
          showConfirmWindow({
            ...confirmUpdateProfile,
            onOk: () => {
              cbSubmit(fieldsValue);
            }
          });
        } else {
          message.error("Заполните все поля");
        }
      });
    } else {
      console.log("Error", name);
    }
  };

  preparePhone = phone => {
    const phoneList = phone
      ? phone.match(/^(\+7|\+380|\+375|\+995|\+374|\+994|\+77|)(.*)/)
      : "";

    return {
      phoneCode: phoneList[1],
      phoneNumber: phoneList[2]
    };
  };

  render() {
    const { profileInfo, userId, userInfo } = this.props;
    const { isEditable } = this.state;

    return (
      <div className="site-wrapper">
        <Row className="offer-create__form-wrap" style={{ display: "flex" }}>
          <Col
            span={18}
            className="order-create__form"
            style={{ paddingTop: 0 }}
          >
            {profileInfo ? (
              <ProfileInfo
                name="formProfileInfo"
                data={{
                  ...userInfo,
                  role: profileInfo.role,
                  roleKey: profileInfo.roleKey,
                  userId: userId,
                  phoneNumber: this.preparePhone(userInfo.phone)["phoneNumber"]
                }}
                userId={userId}
                getForm={this.getForm}
                setForm={this.setForm}
                updateProgress={this.updateProgress}
                isEditable={this.state.isEditable}
              />
            ) : (
              <Skeleton active />
            )}
          </Col>
          <Col span={6} className="offer-card__sidebar">
            <Affix
              offsetTop={18}
              target={() => document.getElementById("mainSheet")}
            >
              <React.Fragment>
                {!isEditable ? (
                  <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    className="offers-create__submit"
                    style={{ width: 176 }}
                    onClick={this.handleClickEdit}
                  >
                    Редактировать
                  </Button>
                ) : (
                  <React.Fragment>
                    <Button
                      type="primary"
                      htmlType="submit"
                      size="large"
                      className="offers-create__submit"
                      style={{ width: 176 }}
                      onClick={this.updateProfile}
                      disabled={this.state.disabledSaveButton}
                    >
                      Сохранить
                    </Button>
                    <Button
                      type="primary"
                      htmlType="submit"
                      size="large"
                      className="offers-create__submit"
                      style={{ width: 176, marginTop: 16 }}
                      ghost
                      onClick={this.handleCancelEdit}
                    >
                      Отмена
                    </Button>
                  </React.Fragment>
                )}
              </React.Fragment>
            </Affix>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect(
  state => ({
    activeProfile: state.Authorization.activeProfile,
    profileInfo: state.SystemSettings.profileInfo.info,
    userInfo: state.Authorization.user.info,
    userId: state.Authorization.user.id,
    updateSuccess: state.SystemSettings.profileInfo.updateSuccess
  }),
  {
    setCaption,
    getProfileInfo,
    updateProfileInfo,
    updateUserAction
  }
)(MyProfile);
